<template>
    <div>
        <v-dialog v-model="show" @click:outside="close" width="500">
            <!--<v-container fluid style="padding: 0px!important;overflow: hidden;">-->
            <div class="modal">
                <v-row>
                    <v-col class="icon-modal remove few table-cell" style="max-width: 32px !important;">
                    </v-col>
                    <v-col class="table-cell modal-content" style="padding: 0px!important;">
                        <div class="d-flex justify-space-between">
                            <h6 class="modal-title mb-5"
                                style="position: relative;text-align: center;font-size: 25px !important;line-height: 34px;">
                                The invoice is not yet available</h6>
                        </div>
                    </v-col>
                </v-row>
                <v-row>
                    <v-col cols="1" class="icon-modal remove" style="max-width: 32px!important;"></v-col>
                    <v-col cols="11" class="text-center">
                        <div id="page-loader"></div>
                    </v-col>
                </v-row>
            </div>
        </v-dialog>
    </div>
</template>
<script>
    export default {
        props: ['show', 'hide', 'url', 'sender_profile_picture_invoice'],
        components: {
        },
        data() {
            return {

            }
        },
        methods: {
            close: function () {
                this.hide();
                let _CANVAS = document.querySelector('#pdf-canvas');
                let context = _CANVAS.getContext('2d');
                context.clearRect(0,0,_CANVAS.width, _CANVAS.height);
                document.querySelector("#page-loader").style.display = 'block';
            }
        },
    };
</script>